import React, { ReactNode } from 'react';
import { Box } from '@clariness/clarikit-react';
import {
  AuthPageLayoutFooter,
  AuthPageLayoutForm,
  AuthPageLayoutHeading,
  AuthPageLayoutInfoLinks,
  AuthPageLayoutLogo,
  AuthPageLayoutParagraph,
} from './components';

type ErrorMessage = {
  title: string;
  description: string;
};

type AuthPageLayoutProps = {
  children: ReactNode;
  error?: ErrorMessage | null;
};

export const AuthPageLayout = ({ error, children }: AuthPageLayoutProps) => {
  return (
    <Box
      as="main"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      backgroundColor="color-gray-variant-6"
    >
      <Box
        as="section"
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="450px"
        backgroundColor="color-white-variant-1"
        padding="24px 24px 32px"
        style={{
          borderRadius: 'var(--c-border-radius-4)',
          boxShadow: '0 3px 6px rgb(0 0 0 / 20%)',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        {Boolean(error) && (
          <Box
            as="aside"
            role="alert"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            backgroundColor="color-red-variant-3"
            paddingY="16px"
            style={{
              borderRadius: '20px 20px 0 0',
              color: 'var(--c-color-white-variant-1)',
              left: 0,
              position: 'absolute',
              top: 0,
            }}
          >
            <Box as="strong" style={{ fontSize: '18px' }}>
              {error?.title}
            </Box>
            <Box as="span" style={{ fontSize: '15px' }}>
              {error?.description}
            </Box>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

AuthPageLayout.Logo = AuthPageLayoutLogo;
AuthPageLayout.Heading = AuthPageLayoutHeading;
AuthPageLayout.Paragraph = AuthPageLayoutParagraph;
AuthPageLayout.Form = AuthPageLayoutForm;
AuthPageLayout.InfoLinks = AuthPageLayoutInfoLinks;
AuthPageLayout.Footer = AuthPageLayoutFooter;
